// extracted by mini-css-extract-plugin
module.exports = {"container":"NavBar_container__3m72l","img":"NavBar_img__ygzRY","title":"NavBar_title__2HEif","link":"NavBar_link__16jAf"};